RivalIQ.module('state', function (state, App, Backbone, Marionette, $, _) {

    'use strict';

    const branding = state.branding = new Backbone.Collection();

    branding.setActive = function (model) {
        const me = this;
        state.landscape.set('activeBranding', model.id);

        me.each(function (child) {
            child.set('active', child.id === model.id);
        });
    };

    branding.listenTo(branding, 'remove', function (model) {
        const me = this;

        if (model.get('active')) {
            me.first().set('active', true);
        }
    });

    function initializeBrandingStateFromProperties(state) {
        const branding = RivalIQ.utils.branding;


        const types = [branding.types.DEFAULT];
        const active = branding.getActiveBrandingTypeOrDefault();

        if (RivalIQ.state.account.canCustomizeBranding()) {
            types.push(branding.types.CUSTOM);
        }

        _.each(types, function (type) {
            const model = branding.getBranding(type, RivalIQ.state.view.get('landscapeId'));

            if (model) {
                model.set('active', type === active);
                state.add(model);
            }
        });
    }

    (function () {

        let hasInitialized = false;

        branding.initialize = function (properties) {
            if (hasInitialized) {
                throw 'not supported: branding state cannot be initialized more than once.';
            }

            initializeBrandingStateFromProperties(this, properties);

            hasInitialized = true;
        };

    }());
});
